import styled from "styled-components";
import { media } from "../../theme/theme";

export const PanelWithPreviewBR = 800;

export const MediaEditingWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;

    ${media.custom(PanelWithPreviewBR)} {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    > div {
        &:first-child {
            margin-bottom: 20px;

            ${media.custom(PanelWithPreviewBR)} {
                min-height: 350px;
                margin-bottom: 0;
            }
        }

        &:first-child,
        &:nth-child(2) {
            ${media.custom(PanelWithPreviewBR)} {
                max-width: calc(50% - 30px);
                width: 100%;
            }
        }        
    }
`;

export const PreviewLabelWrapper = styled.div`
    max-width: 380px;
  
    ${media.custom(PanelWithPreviewBR)} {
        margin: 0 auto;
    }
`;


export const PanelWithPreviewShowMobile = styled.div<{ mobileDisplay?: string }>`
    display: ${({ mobileDisplay }) => mobileDisplay ? mobileDisplay : "block"};

    ${media.custom(PanelWithPreviewBR)} {
        display: none;
    }
`;

export const PanelWithPreviewShowDestkop = styled.div<{ $desktopDisplay?: string }>`
    display: none;

    ${media.custom(PanelWithPreviewBR)} {
        display: ${({ $desktopDisplay }) => $desktopDisplay ? $desktopDisplay : "block"};
    }
`;